var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 304,
    viewBox: "0 0 263 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2.01172,
    width: 260,
    height: 300,
    rx: 130,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "6 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanGuide);
export default __webpack_public_path__ + "static/media/scanGuide.b5b51c142fe8638986356e64c2cbedf3.svg";
export { ForwardRef as ReactComponent };